import { render } from "./ErrorSigningDoc.vue?vue&type=template&id=30d4d4c1&scoped=true"
import script from "./ErrorSigningDoc.vue?vue&type=script&lang=js"
export * from "./ErrorSigningDoc.vue?vue&type=script&lang=js"

import "./ErrorSigningDoc.vue?vue&type=style&index=0&id=30d4d4c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d4d4c1"]])

export default __exports__